<footer>
    <span>
        &copy; Copyright {{currentYear}} Introhive Services, Inc.
    </span>
</footer>
